exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".policy-type-select{input{display:none}.v-select__selections{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-77c3ed14","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=2!./resources/js/components/b2b/PolicyList.vue
// module id = tJ20
// module chunks = 0 2